import "./style.css"
import "../../styles/screen.css"
import {ButtonStart} from "../Buttons"
import logo from "../../imgs/logo_grey.svg"


export const Header = ( { eventFunction } )=>{
   return(
    <header className="container-header flex items-center justify-center">
        <div className="default-screen-size flex items-center justify-center">
            <div className="container flex items-center justify-between">
                <img src={logo} alt="logo"/>
                <ButtonStart text="Inicio" event={eventFunction}/>
            </div> 
        </div>
    </header>
   )
}

